import { FC } from 'react';

import Text from 'components/_core/Text';
import DecorativeImage from 'components/DecorativeImage';
import Loader from 'components/Loader';

import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import notAccountHolderImg from '../images/not-account-holder.svg';
import { useAccountHolder } from './hooks';
import locales from './locales';

const NotAccountHolder: FC = () => {
  const { accountHolder, loading } = useAccountHolder();

  const accountHolderName = `${accountHolder?.firstName} ${accountHolder?.lastName}`;

  return (
    <Wrapper>
      {loading ? (
        <Loader />
      ) : (
        <>
          <DecorativeImage src={notAccountHolderImg} />
          <Title>{locales.title}</Title>
          <Text size="sm">
            {locales.formatString(locales.body, {
              accountHolderName,
            })}
          </Text>
        </>
      )}
    </Wrapper>
  );
};

export default NotAccountHolder;
